import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import '../../assets/css/auth.css';

export default function ForgotPassword() {
  const [email, setEmail]   = useState('');
  const [msg, setMsg]       = useState('');
  const [err, setErr]       = useState('');
  const [loading, setLoad]  = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setErr(''); setMsg(''); setLoad(true);
    try {
      const r = await api.post('/auth/forgot-password', { email });
      setMsg(r.data?.message || 'If an account exists, a reset link has been sent.');
    } catch (e2) {
      setErr(e2.response?.data?.error || 'Request failed');
    } finally {
      setLoad(false);
    }
  }

  return (
    <div className="auth">
      <aside className="auth-aside">
        <Link to="/" className="auth-brand"><span className="mark" />CopyTrade</Link>
        <div className="auth-aside-body">
          <span className="auth-eyebrow">Account recovery</span>
          <h2 className="auth-headline">Locked out?</h2>
          <p className="auth-sub">
            Enter the email tied to your account and we'll send a secure link to reset your password.
          </p>
        </div>
        <span className="auth-foot">Trading involves substantial risk of loss.</span>
      </aside>

      <main className="auth-main">
        <div className="auth-card">
          <h1>Forgot password</h1>
          <p className="auth-card-sub">We'll email you a reset link.</p>

          {err && <div className="auth-alert">{err}</div>}
          {msg && <div className="auth-alert is-success">{msg}</div>}

          <form onSubmit={handleSubmit}>
            <div className="auth-field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                className="auth-input"
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </div>
            <button type="submit" className="auth-submit" disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>

          <p className="auth-switch">
            <Link to="/login" className="auth-link">← Back to sign in</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
